module.exports = __webpack_public_path__ + "static/A5-Bas-de-page.63fdd69f.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/A5-Bas-de-page.jpg
// module id = 874
// module chunks = 168707334958949